import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaThanhTraThamNhungPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='THANH_TRA_THAM_NHUNG'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaThanhTraThamNhungPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaThanhTraThamNhungPage.jsx